// extracted by mini-css-extract-plugin
export default {"confirmSection":"SystemErrorMessage_confirmSection__Tip5j","errorIcon":"SystemErrorMessage_errorIcon__3dq9V","confirmBold":"SystemErrorMessage_confirmBold__TbdCv"};